import { useFeatureValue } from '@shared/core/featureFlags';

/**
 * Determines whether the Contact Collection Message feature is enabled.
 *
 * Wraps the `enableContactCollectionMessage` Amplitude feature flag.
 *
 * @returns `[isEnabled, isLoading]` tuple
 */
export const useIsContactCollectionMessageEnabled = (): [isEnabled: boolean, isLoading: boolean] => {
  const { value, loading } = useFeatureValue('enableContactCollectionMessage');
  return [value === 'on', loading];
};
